"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = handleError;
const errors_1 = require("@invivodf/errors");
function isAxiosError(error) {
    return error.isAxiosError ?? false;
}
// Helper function to check if data has the structure of an error response
function isErrorData(value) {
    return value && typeof value.key === 'string' && typeof value.message === 'string';
}
/**
 * Helper method used to simplify axios error handling
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function handleError(error) {
    if (!isAxiosError(error)) {
        throw new errors_1.DomainError('Unhandled error', 'technical.unknown');
    }
    if (!error.response) {
        throw new errors_1.DomainError('No Response', 'technical.unknown');
    }
    const data = error.response.data;
    if (isErrorData(data)) {
        throw new errors_1.DomainError(data.message, data.key);
    }
    if (error.response.status === 401) {
        throw new errors_1.DomainError('Client not authenticated', 'technical.unauthorized');
    }
    if (error.response.status === 403) {
        throw new errors_1.ForbiddenError('Client is missing permissions');
    }
    if (error.response.status === 422) {
        throw new errors_1.DomainError(error.response.data.message, error.response.data.error);
    }
    throw new errors_1.DomainError('Unsupported error', 'technical.unknown');
}
